






















import _ from "underscore";
import { Component, Prop, Vue } from "vue-property-decorator";

import ListArea from "@/components/common/list/ListArea.vue";
import ListItem from "@/components/common/list/ListItem.vue";
import ListItemRowNohover from "@/components/common/list/ListItemRowNohover.vue";
import GreenUnderlineText from "@/components/common/text/GreenUnderlineText.vue";
import ImportantOldListItem from "@/components/important-message/ImportantOldListItem.vue";
import { ImportantMessageInterface } from "@/interfaces/important-message.interface";
import { MessageUtil } from "@/utils/message.util";

interface YearEventList {
  year: string;
  messages: ImportantMessageInterface[];
}

@Component({
  components: {
    GreenUnderlineText,
    ImportantOldListItem,
    ListItem,
    ListItemRowNohover,
    ListArea,
  },
})
export default class ImportantOldList extends Vue {
  @Prop({ required: true }) messages!: ImportantMessageInterface[];

  private get yearEventLists(): YearEventList[] {
    return this.parse(this.getYears(this.messages), this.messages);
  }

  private getYears(messages: ImportantMessageInterface[]): string[] {
    return _.uniq(
      messages.map((message: ImportantMessageInterface) => this.getYear(message))
    )
      .sort()
      .reverse();
  }

  private parse(
    years: string[],
    messages: ImportantMessageInterface[]
  ): YearEventList[] {
    const data: { [key: string]: ImportantMessageInterface[] } = {};

    years.forEach((year: string) => {
      data[year] = [];
    });
    messages.forEach((message: ImportantMessageInterface) => {
      data[this.getYear(message)].push(message);
    });

    return years.map((year: string) => ({
      year: year,
      messages: data[year],
    }));
  }

  private getYear(message: ImportantMessageInterface): string {
    return MessageUtil.getYear(message.displayDate);
  }
}
